import { generic } from 'apis';
import { ProjectTables } from 'enums';

export const COMPETITION_BANNER_FILE_TYPE_CODE = 'COMP-BANNER';

const getFieldValue = (source, camelKey, pascalKey) => source?.[camelKey] ?? source?.[pascalKey] ?? '';

const getAssetSrc = (path) => {
    if (!path || typeof path !== 'string') return '';

    const trimmed = path.trim();
    if (!trimmed || /^(https?:|data:|blob:)/i.test(trimmed)) return trimmed;

    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const getCompetitionId = (item) => getFieldValue(item, 'id', 'Id') || getFieldValue(item, 'competitionId', 'CompetitionId');

export const getCompetitionBannerSrc = (item) =>
    getAssetSrc(
        getFieldValue(item, 'bannerPath', 'BannerPath') ||
            getFieldValue(item, 'bannerImagePath', 'BannerImagePath') ||
            getFieldValue(item, 'imagePath', 'ImagePath') ||
            getFieldValue(item, 'competitionImagePath', 'CompetitionImagePath') ||
            getFieldValue(item, 'avatarPath', 'AvatarPath') ||
            getFieldValue(item, 'logoPath', 'LogoPath') ||
            getFieldValue(item, 'photoPath', 'PhotoPath') ||
            getFieldValue(item, 'filePath', 'FilePath')
    );

const getFirstFilePage = (fileGroups) => {
    const groups = Array.isArray(fileGroups) ? fileGroups : [];
    const bannerGroup = groups.find(
        (group) =>
            String(group?.code ?? group?.Code ?? '').toUpperCase() === COMPETITION_BANNER_FILE_TYPE_CODE ||
            String(group?.abbr ?? group?.Abbr ?? '').toLowerCase() === 'compbanner' ||
            Number(group?.type ?? group?.Type) === 91
    );

    return bannerGroup?.files?.flatMap((bundle) => bundle?.pages ?? [])?.find((page) => page?.id && page?.contentType?.startsWith('image/'));
};

const toImageDataUrl = (base64, contentType) => {
    if (!base64 || typeof base64 !== 'string') return '';
    if (base64.startsWith('data:')) return base64;

    return `data:${contentType || 'image/jpeg'};base64,${base64}`;
};

export const getCompetitionBanner = async (competitionId) => {
    if (!competitionId) return null;

    const fileGroups = await generic.getFilesForPublic({
        DataKey: COMPETITION_BANNER_FILE_TYPE_CODE,
        DataValue: null,
        RecordId: null,
        RecordGuid: competitionId,
        ProjectTableId: ProjectTables.Competition,
        UserId: null
    });
    const file = getFirstFilePage(fileGroups);
    if (!file) return null;

    const base64 = await generic.downloadFileAsBase64({ Id: file.id });

    return {
        fileId: file.id,
        src: toImageDataUrl(base64, file.contentType),
        alt: file.origFName || file.title || ''
    };
};
